import {CSSProperties, FC} from 'react';


export interface IIconOfferProps {
    className?: string;
    color?: string;
    size?: string;
    style?: CSSProperties;
}

export const IconOffer: FC<IIconOfferProps> = (props) => {
    const {
        className,
        color,
        size,
        style = {},
    } = props;

    /* eslint-disable max-len */
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            className={className}
            fill="currentColor"
            width="1em"
            height="1em"
            style={{
                display: 'inline-block',
                flexShrink: 0,
                color,
                fontSize: size,
                lineHeight: '1em',
                ...style,
            }}
        >
            <path fillRule="evenodd" d="m20.172 12 .79 2.059a.564.564 0 0 1-.17.638l-1.714 1.389-.346 2.178a.564.564 0 0 1-.467.467l-2.179.347-1.388 1.713a.563.563 0 0 1-.639.17L12 20.173l-2.058.79a.56.56 0 0 1-.639-.171l-1.388-1.713-2.179-.347a.564.564 0 0 1-.467-.467l-.346-2.178-1.713-1.389a.563.563 0 0 1-.171-.637l.79-2.06-.79-2.06a.563.563 0 0 1 .17-.637l1.714-1.389.346-2.178a.564.564 0 0 1 .467-.467l2.179-.347L9.302 3.21a.56.56 0 0 1 .638-.17l2.06.789 2.058-.791a.564.564 0 0 1 .639.171l1.388 1.713 2.179.347c.24.038.428.227.467.466l.346 2.18L20.79 9.3a.563.563 0 0 1 .171.64L20.171 12Zm-.409 2.08-.72-1.879a.566.566 0 0 1 0-.402l.72-1.879L18.2 8.653a.56.56 0 0 1-.202-.348l-.316-1.988-1.988-.316a.56.56 0 0 1-.348-.201l-1.267-1.565-1.878.721a.565.565 0 0 1-.403 0l-1.879-.721-1.265 1.564a.56.56 0 0 1-.349.2l-1.987.317L6 8.304a.56.56 0 0 1-.202.348L4.235 9.92l.72 1.88c.05.129.05.273 0 .403l-.72 1.879 1.564 1.266a.56.56 0 0 1 .202.348l.316 1.988 1.987.316a.56.56 0 0 1 .349.201l1.267 1.565 1.878-.721a.559.559 0 0 1 .404 0l1.879.72 1.264-1.564a.56.56 0 0 1 .348-.201l1.988-.316.316-1.988a.56.56 0 0 1 .202-.348l1.564-1.267ZM8.625 9.188c0-.93.757-1.688 1.687-1.688S12 8.258 12 9.188a1.69 1.69 0 0 1-1.688 1.687 1.69 1.69 0 0 1-1.687-1.687Zm1.125 0a.563.563 0 1 0 1.125 0 .563.563 0 0 0-1.125 0Zm3.937 3.937a1.69 1.69 0 0 0-1.688 1.687c0 .93.758 1.688 1.688 1.688a1.69 1.69 0 0 0 1.687-1.688 1.69 1.69 0 0 0-1.687-1.687Zm0 2.25a.563.563 0 1 1 0-1.126.563.563 0 0 1 0 1.126Zm.668-7.638a.563.563 0 0 1 .914.653l-5.624 7.874a.562.562 0 0 1-.914-.653l5.624-7.874Z" clipRule="evenodd" />
        </svg>
    );
};
